import { Button, Card, Form, Input, InputNumber, Select, Spin, Row, Col, Icon } from 'antd';
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import DocumentList from "../../components/DocumentList";

class Create extends React.Component {
  constructor() {
    super()
    this.state = {
      documentData: [],
      sublocations: [],
    }
  }

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentDidUpdate(prevProps) {
    // Handle auto-population when data becomes available in edit mode
    if (this.props.data && this.props.data.sublocations &&
      (!prevProps.data || !prevProps.data.sublocations ||
        JSON.stringify(prevProps.data.sublocations) !== JSON.stringify(this.props.data.sublocations))) {

      // Transform the sublocations data to include latitude and longitude from geoLocations
      const transformedSublocations = this.props.data.sublocations.map(sublocation => ({
        _id: sublocation._id,
        latitude: sublocation.geoLocations && sublocation.geoLocations.length > 0
          ? sublocation.geoLocations[0].latitude : 0,
        longitude: sublocation.geoLocations && sublocation.geoLocations.length > 0
          ? sublocation.geoLocations[0].longitude : 0
      }));

      this.setState({ sublocations: transformedSublocations });
    }
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  addSublocation = () => {
    const { sublocations } = this.state;
    this.setState({
      sublocations: [...sublocations, {
        _id: '',
        latitude: 0,
        longitude: 0
      }]
    });
  };

  removeSublocation = (index) => {
    const { sublocations } = this.state;
    const newSublocations = sublocations.filter((_, i) => i !== index);
    this.setState({
      sublocations: newSublocations
    });
  };

  updateSublocation = (index, field, value) => {
    const { sublocations } = this.state;
    const newSublocations = [...sublocations];
    newSublocations[index] = {
      ...newSublocations[index],
      [field]: value
    };
    this.setState({ sublocations: newSublocations });
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData, sublocations } = this.state;
      const data = Object.assign({}, values);
      // data.documents = documentData;
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }

      // Add sublocations to the data - filter out empty entries and structure properly
      data.sublocations = sublocations.filter(sublocation =>
        sublocation._id && sublocation._id.trim() !== ''
      ).map(sublocation => ({
        _id: sublocation._id,
        latitude: sublocation.latitude || 0,
        longitude: sublocation.longitude || 0
      }));
      // console.log(data)
      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  renderSublocationForm = () => {
    const { sublocations } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { match, data, authUser } = this.props;
    const isEditMode = match.params && match.params.id;
    const clients = authUser && authUser.clients || [];

    // Get all selected client IDs to prevent duplicates
    const selectedClientIds = sublocations
      .map(sublocation => sublocation._id)
      .filter(id => id && id.trim() !== '');

    return (
      <div style={{ marginTop: 16, marginBottom: 16, padding: 0 }}>
        <h3 style={{ marginBottom: 16 }}>Sublocation Geo Tags</h3>
        <p style={{ color: '#666', fontSize: '12px', marginBottom: 16 }}>
          Add sublocation geo tags if needed. Latitude and longitude default to 0 if not specified.
        </p>
        {sublocations.length === 0 ? (
          <div style={{
            padding: 16,
            border: '1px dashed #d9d9d9',
            borderRadius: '6px',
            backgroundColor: '#fafafa',
            textAlign: 'center',
            color: '#666'
          }}>
            No sublocations added yet. Click "Add Sublocation Geo Tags" to add one.
          </div>
        ) : (
          sublocations.map((sublocation, index) => {
            // console.log('sublocation****:', sublocation)
            return (
              <div
                key={index}
                style={{
                  marginBottom: 16,
                  padding: 16,
                  border: '1px solid #d9d9d9',
                  borderRadius: '6px',
                  backgroundColor: '#fafafa'
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16,
                  borderBottom: '1px solid #e8e8e8',
                  paddingBottom: 8
                }}>
                  <h4 style={{ margin: 0 }}>
                    Sublocation {index + 1}
                  </h4>
                  <Button
                    type="danger"
                    size="small"
                    icon="delete"
                    onClick={() => this.removeSublocation(index)}
                  >
                    Remove
                  </Button>
                </div>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Client" required>
                      {getFieldDecorator(`sublocation_${index}_client`, {
                        rules: [{ required: true, message: 'Client is required!' }],
                        initialValue: sublocation._id || ''
                      })(
                        <Select
                          showSearch
                          placeholder="Select a client"
                          filterOption={(input, option) =>
                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                          }
                          onChange={(value) => this.updateSublocation(index, '_id', value)}
                        >
                          {clients.map(client => {
                            // Check if this client is already selected in another sublocation
                            const isAlreadySelected = selectedClientIds.includes(client._id) &&
                              sublocation._id !== client._id;

                            return (
                              <Select.Option
                                key={client._id}
                                value={client._id}
                                disabled={isAlreadySelected}
                              >
                                {client.name}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Latitude">
                      {getFieldDecorator(`sublocation_${index}_latitude`, {
                        initialValue: sublocation.latitude || 0
                      })(
                        <InputNumber
                          style={{ width: '100%' }}
                          placeholder="Enter latitude (default: 0)"
                          step="any"
                          onChange={(value) => this.updateSublocation(index, 'latitude', value)}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Longitude">
                      {getFieldDecorator(`sublocation_${index}_longitude`, {
                        initialValue: sublocation.longitude || 0
                      })(
                        <InputNumber
                          style={{ width: '100%' }}
                          placeholder="Enter longitude (default: 0)"
                          step="any"
                          onChange={(value) => this.updateSublocation(index, 'longitude', value)}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            );
          })
        )}
        <Button
          type="dashed"
          onClick={this.addSublocation}
          style={{ width: '100%' }}
          icon="plus"
        >
          Add Sublocation Geo Tags
        </Button>
      </div>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, subDocumentFilters, form } = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {

              if (filters[item].type === 'String') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: true, message: `${item} is required!` }],
                    initialValue: item !== 'password' ? data && data[item] : ''
                  })(<Input />)
                  }
                </Form.Item>
              }

              // if (filters[item].type === 'Array' && item !== 'documents') {
              //   return <Form.Item key={item} label={sanitizeFieldName(item)}>
              //     {getFieldDecorator(item, {
              //       rules: [{ required: true, message: `${sanitizeFieldName(item)} is required!` }],
              //       initialValue: (data && data[item]) ? data[item].map(field => field._id) : []
              //     })(<Select
              //       mode="multiple"
              //       style={{ width: '100%' }}
              //       placeholder="Please select"
              //     >
              //       {filters[item] && filters[item].data && filters[item].data.data && filters[item].data.data.map(item => <Select.Option key={item._id}
              //         value={item._id}>{item.role}</Select.Option>)}
              //     </Select>)
              //     }
              //   </Form.Item>
              // }

              // if (filters[item].type === 'Array' && filters[item].options.ref) {
              //   return <DocumentList match={this.props.match} history={this.props.history} key={item} item={filters[item]} form={form} data={data[item]} subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData} />
              // }

              if (filters[item].type === 'Number' && !filters[item].options.hidden) {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    initialValue: data && data[item]
                  })(<Input type='number' />)
                  }
                </Form.Item>
              }
              return null;

            })}

            {/* Sublocation Form Section */}
            {this.renderSublocationForm()}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
